import { detect } from 'detect-browser';
import Notice from '~/components/Notice';
import { capitalize } from 'utils';

export default function BrowserCompatibilityNotice() {
  const browser = detect();

  return (
    <div className="padded-content mt-1">
      <Notice>
        <h3>OBS!</h3>
        <p>
          För bästa upplevelse rekommenderar vi att du använder <strong>Google Chrome</strong>,{' '}
          <strong>Microsoft Edge</strong> eller en annan Chromium-baserad webbläsare.
        </p>
        <p>
          Tyvärr stödjer din webbläsare, <strong>{!!browser && browser?.name && capitalize(browser?.name)}</strong>,
          inte all funktionalitet som krävs för ljudinspelning i den här webbaserade mjukvaran. Det kan innebära att
          inspelning av hjärt- och lungauskultation inte fungerar som förväntat.
        </p>
      </Notice>
    </div>
  );
}
